import { Link } from "react-router-dom";
import { people } from "@/mocks/people";

export default function PeopleShowcase() {
  const featured = people.slice(0, 3);

  return (
    <section className="w-full bg-background-100">
      <div className="container-x py-14 md:py-20">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="eyebrow">
              <i className="ri-user-star-line" aria-hidden="true" />
              新晋主角
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              本周最受关注的爆红人物
            </h2>
          </div>
          <Link
            to="/renwu"
            className="hidden shrink-0 items-center gap-1.5 font-label text-sm text-primary-600 hover:text-primary-700 sm:inline-flex cursor-pointer"
          >
            进入热门主角档案
            <i className="ri-arrow-right-up-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:mt-12 sm:grid-cols-3">
          {featured.map((p) => (
            <Link to="/renwu" key={p.id} className="group block cursor-pointer">
              <div className="relative aspect-[4/5] overflow-hidden rounded-lg bg-background-200">
                <img
                  src={p.img}
                  alt={`新晋网红 ${p.name}（${p.nick}）插画档案`}
                  title={`${p.name} 热门主角`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 font-label text-xs font-medium text-primary-700">
                  <i className="ri-fire-line" aria-hidden="true" />
                  {p.heat}
                </span>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/90 to-transparent p-4 pt-12">
                  <span className="font-label text-xs text-accent-400">{p.categoryLabel}</span>
                  <h3 className="mt-1 font-heading text-xl font-bold text-background-50">{p.name}</h3>
                  <p className="mt-0.5 text-xs text-background-200">{p.nick}</p>
                </div>
              </div>
              <div className="mt-3 flex items-center justify-between gap-3">
                <p className="line-clamp-1 flex-1 text-sm text-foreground-700">{p.intro}</p>
                <span className="inline-flex shrink-0 items-center gap-0.5 font-label text-xs text-secondary-600">
                  <i className="ri-arrow-up-line" aria-hidden="true" />
                  {p.trend}
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <Link to="/renwu" className="btn-ghost cursor-pointer">
            浏览全部热门主角
            <i className="ri-arrow-right-up-line" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}